export default function TopDesign() {
  return (
    <>
      <div className="topHolder">
        <div className="middleOpening"></div>

        <div className="textContainer">
          <p>pocket calculator</p>
        </div>

        <div className="legsContainer">
          <div className="leg"></div>

          <div className="leg"></div>
        </div>
      </div>

      <div className="top">
        <div className="topLogos">
          <p className="KOtext">
            J . F <span className="exPoint">!</span>
          </p>
        </div>

        <div className="topLogos"></div>

        <div className="topLogos"></div>
      </div>
    </>
  );
}
